export default __webpack_public_path__ + "static/blob9-ce3807375066de62ad9359c8050360c3.svg";